import React from "react";
import Badge from "@material-ui/core/Badge";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {default_player_image_url} from "../../../../utils/constantInformation.js"

// Custom styling
const RedBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#f44336", // Example red color
    color: theme.palette.getContrastText("#f44336"), // Ensure text color is readable on yellow background
    // When badgeContent is a number, it will use this style
    "& .MuiBadge-dot": {
      width: 12,
      height: 12,
      borderRadius: "50%",
    },
  },
}))(Badge);
// Custom styling
const YellowBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#ffeb3b", // Example yellow color
    color: theme.palette.getContrastText("#ffeb3b"), // Ensure text color is readable on yellow background
    // When badgeContent is a number, it will use this style
    "& .MuiBadge-dot": {
      width: 12,
      height: 12,
      borderRadius: "50%",
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "inline-block", // Or 'block' depending on your layout
  },
  image: {
    // Styles for your image (width, height, etc.)
    display: "block",
    maxWidth: "100%",
    height: "auto",
  },
  badge: {
    position: "absolute",
    "& .MuiBadge-badge": {
      // Optional: styles for the badge itself
    },
  },
  topRight: {
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  topLeft: {
    top: theme.spacing(1),
    left: theme.spacing(1),
  },
  bottomRight: {
    bottom: theme.spacing(1),
    right: theme.spacing(1),
  },
  bottomLeft: {
    bottom: theme.spacing(1),
    left: theme.spacing(1),
  },
  badgeCustom: {
    // Placeholder for custom styles passed via props
  },
}));

function ImageWithBadges({
  imageUrl,
  styling,
  metadata,
  props,
  topRight,
  bottomRight,
  topLeft,
}) {
  const classes = useStyles();
  // console.log("bottom right: ", bottomRight);
  // console.log("metadata: ", metadata);
  return (
    <div className={classes.container}>
      <img src={imageUrl}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src=default_player_image_url;
      }}
      alt="Complex Example"
      className={styling} />
      {/* Position badges in all four corners */}
      {topRight !== null && (
        <Badge
          variant={topRight.variant}
          color={topRight.color}
          className={`${classes.badge} ${classes.topRight}`}
          badgeContent={topRight.badgeContent}
          style={topRight.customStyles}
        />
      )}
      {bottomRight !== null && (
        <Badge
          variant={bottomRight.variant}
          color={bottomRight.color}
          className={`${classes.badge} ${classes.bottomRight}`}
          badgeContent={bottomRight.badgeContent}
          style={bottomRight.customStyles}
        />
      )}
      {topLeft !== null && topLeft.badgeContent === "Q" ? (
        <YellowBadge
          className={`${classes.badge} ${classes.topLeft}`}
          badgeContent={topLeft.badgeContent}
        />
      ) : topLeft !== null && topLeft.badgeContent === "O" ? (
        <RedBadge
          className={`${classes.badge} ${classes.topLeft}`}
          badgeContent={topLeft.badgeContent}
        />
      ) : null}
    </div>
  );
}

export default ImageWithBadges;
